import { cn } from '@fe-learner-common';
import { FC, ReactNode } from 'react';

type TabPageProps = {
  className?: string;
  children: ReactNode;
  title: string;
  actions?: ReactNode;
};

export const TabPage: FC<TabPageProps> = ({
  className,
  children,
  title,
  actions,
}) => {
  return (
    <div className={cn('flex flex-col px-4', className)}>
      <div className="flex flex-1 justify-between ">
        <h2 className="py-1.5 pb-4 text-title-lg">{title}</h2>
        {actions}
      </div>
      {children}
    </div>
  );
};
